var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Success Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.96441 1.41239C8.47053 1.17519 10.0124 1.46154 11.333 2.22346C11.6229 2.39074 11.7226 2.76166 11.5553 3.05158C11.388 3.34123 11.0177 3.44025 10.7279 3.27316C9.64724 2.64964 8.38507 2.41565 7.15262 2.60982C5.9202 2.804 4.79176 3.41506 3.95517 4.34062C3.11869 5.26611 2.6244 6.45013 2.55531 7.6957C2.48629 8.94142 2.84668 10.1734 3.57591 11.1857C4.30508 12.198 5.35908 12.9297 6.56242 13.2588C7.76582 13.588 9.04595 13.4949 10.1888 12.9946C11.3318 12.4943 12.2684 11.617 12.843 10.5096C13.4175 9.40214 13.5956 8.13126 13.3465 6.90877C13.2797 6.58089 13.491 6.26053 13.8188 6.19358C14.1468 6.12676 14.4671 6.33869 14.534 6.66659C14.8385 8.16077 14.6212 9.71425 13.919 11.0678C13.2168 12.4212 12.0721 13.4932 10.6754 14.1047C9.27844 14.7162 7.71369 14.8308 6.24282 14.4286C4.772 14.0263 3.48352 13.1317 2.59224 11.8945C1.70097 10.6572 1.26072 9.15148 1.34508 7.62894C1.42945 6.1064 2.03351 4.65868 3.05602 3.52742C4.07852 2.39626 5.45817 1.64969 6.96441 1.41239Z",
    fill: "#464E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6323 2.72315C13.869 2.48647 14.2528 2.48647 14.4895 2.72315C14.7259 2.95977 14.7259 3.34306 14.4895 3.57968L8.42843 9.64068C8.1918 9.87705 7.80851 9.87705 7.57189 9.64068L5.75371 7.82252C5.51702 7.58584 5.51702 7.20197 5.75371 6.96529C5.99036 6.72877 6.37359 6.72877 6.61024 6.96529L8.00016 8.35519L13.6323 2.72315Z",
    fill: "#464E5F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifSuccess);
export default __webpack_public_path__ + "static/media/notif-success.8a8db40dc71ef2203fb4d2d9efccda08.svg";
export { ForwardRef as ReactComponent };